<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import SNB from '../../../../../layouts/nav/SNB.vue';
import MyPageCorpInfoView from './corpInfo/MyPageCorpInfoView.vue';
import MyPageJobPostingView from './jobPosting/MyPageJobPostingView.vue';
import MyPageInterestedTalentView from './interestedTalent/MyPageInterestedTalentView.vue';
import MyPageInterviewOffersView from './interviewOffers/MyPageInterviewOffersView.vue';
import router from '../../../../../router';

const route = useRoute();

const tabRef = ref(null);
const tabOptions = [
  { label: '기업정보 관리', value: 'corp-info' },
  { label: '채용공고 관리 및 입사지원 현황', value: 'job-postings' },
  { label: '관심인재', value: 'interested-talent' },
  { label: '보낸 면접제안', value: 'interview-offers' },
];

const selectedTabValue = ref(tabOptions[0].value);

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;
  router.push({ query: { tab: tab.value } });
};

onMounted(() => {
  const tabFromQuery = route.query.tab;
  if (tabFromQuery && tabOptions.some(option => option.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  }
});
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <div class="content">
          <div class="sub-title">
            <h3>상시채용관 현황</h3>
          </div>
          <div class="tab-wrap">
            <KSATab
              ref="tabRef"
              :options="tabOptions"
              @change="onChangeTab"
              style="grid-template-columns: repeat(4, 1fr);"
            />
          </div>

          <div v-if="selectedTabValue === 'corp-info'">
            <MyPageCorpInfoView />
          </div>
          <div v-else-if="selectedTabValue === 'job-postings'">
            <MyPageJobPostingView />
          </div>
          <div v-else-if="selectedTabValue === 'interested-talent'">
            <MyPageInterestedTalentView />
          </div>
          <div v-else-if="selectedTabValue === 'interview-offers'">
            <MyPageInterviewOffersView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>
